import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileHeaderSection from '/component/partial/profile/ProfileHeaderSection';
import {
  accountEmailById,
  avatarUrlById,
  fullNameById,
  rankDescriptionById,
  rankIconNameById,
} from '/redux/selector/coach.selector';

export default connect(
  createStructuredSelector({
    fullName: fullNameById,
    avatarUrl: avatarUrlById,
    accountEmail: accountEmailById,
    rankDescription: rankDescriptionById,
    rankIconName: rankIconNameById,
  }),
  null,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    optaviaId: ownProps.coachId,
  }),
)(ProfileHeaderSection);
